const INITIAL_STATE = {
	dados: {},
	lista: [],
	loading: false,
	error: null,
	detalhe: {},
	linkEmMassa: {
		lista: [],
		loading: true,
		error: null,
	},
	linkSimples: {
		dados: {},
		loading: false,
		error: null,
		status: null,
	},
};

// eslint-disable-next-line default-param-last
export function clientMaquinaVirtual(state = INITIAL_STATE, action) {
	switch (action.type) {
		case '@clientMaquinaVirtual/REQUEST_LINKS':
			return { ...state, loading: true };

		case '@clientMaquinaVirtual/SUCCESS_LINKS':
			return {
				...state,
				dados: { ...action.payload.dados },
				lista: action.payload.dados.lista,
				loading: false,
				erro: null,
			};

		case '@clientMaquinaVirtual/FAILURE_LINKS':
			return {
				...state,
				dados: {},
				lista: [],
				loading: false,
				erro: action.payload.error,
			};

		case '@clientMaquinaVirtual/REQUEST_GERAR_LINK':
			return {
				...state,
				linkSimples: {
					...state.linkSimples,
					loading: true,
					status: null,
				},
			};

		case '@clientMaquinaVirtual/SUCCESS_GERAR_LINK':
			return {
				...state,
				linkSimples: {
					dados: action.payload.dados.data,
					status: action.payload.dados.status,
					loading: false,
					error: null,
				},
			};

		case '@clientMaquinaVirtual/FAILURE_GERAR_LINK':
			return {
				...state,
				linkSimples: {
					dados: {},
					loading: false,
					error: action.payload.error,
					status: null,
				},
			};

		case '@clientMaquinaVirtual/LIMPAR_LINK':
			return {
				...state,
				linkSimples: INITIAL_STATE.linkSimples,
			};

		case '@clientMaquinaVirtual/REQUEST_GERAR_LINK_MASSA':
			return {
				...state,
				linkEmMassa: {
					...state.linkEmMassa,
					loading: true,
				},
			};

		case '@clientMaquinaVirtual/SUCCESS_GERAR_LINK_MASSA':
			return {
				...state,
				linkEmMassa: {
					lista: action.payload.lista,
					loading: false,
					error: null,
				},
			};

		case '@clientMaquinaVirtual/FAILURE_GERAR_LINK_MASSA':
			return {
				...state,
				linkEmMassa: {
					lista: [],
					loading: false,
					error: action.payload.error,
				},
			};
		case '@clientMaquinaVirtual/REQUEST_DETALHE_LINK': {
			const { id } = action.payload;
			const { lista } = state;
			const detalheEncontrado = lista.find((detalhe) => {
				return id === detalhe.cryptogram;
			});
			return {
				...state,
				detalhe: {
					...detalheEncontrado,
					payer_details: JSON.parse(detalheEncontrado.payer_details),
				},
			};
		}
		default:
			return state;
	}
}
